import { userActionTypeEnum } from '@thoughtspot/metrics';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { getClientId } from '@thoughtspot/system-config-service';
import { getDefaultSamlHeaders } from '../constants';
const PROVIDER_ENABLED_STATUS = 'ACTIVE';
const PROVIDER_DISABLED_STATUS = 'INACTIVE';
const DEFULT_GROUP_SUFFIX = '_DefaultGroup';
export const MFA_BANNER_FEATURE_NAME = 'mfaBanner';
export const MFA_FEATURE_ID = 'orion.mfaAccepted';
export const OKTA_PROVIDER_EMAIL = 'OKTA_EMAIL';
export const OKTA_PROVIDER_OTP = 'OKTA_OTP';
export const OKTA_PROVIDER_PUSH = 'OKTA_PUSH';
export const GOOGLE_PROVIDER = 'GOOGLE_OTP';
export var tscliConfigOperationType;
(function (tscliConfigOperationType) {
    tscliConfigOperationType["ADD"] = "add";
})(tscliConfigOperationType || (tscliConfigOperationType = {}));
export var mfaAcceptedState;
(function (mfaAcceptedState) {
    mfaAcceptedState["SHOWBANNER"] = "showBanner";
    mfaAcceptedState["DECLINED"] = "declined";
    mfaAcceptedState["ACCEPTED"] = "accepted";
})(mfaAcceptedState || (mfaAcceptedState = {}));
export const MFA_DISABLED_ACTION_TYPES = {
    OKTA_PUSH: 'OKTA_PUSH_FACTOR_DISABLED',
    OKTA_OTP: 'OKTA_OTP_FACTOR_DISABLED',
    GOOGLE_OTP: 'GOOGLE_OTP_FACTOR_DISABLED',
    OKTA_EMAIL: 'OKTA_EMAIL_FACTOR_DISABLED',
};
export const MFA_ENABLED_ACTION_TYPES = {
    OKTA_PUSH: 'OKTA_PUSH_FACTOR_ENABLED',
    OKTA_OTP: 'OKTA_OTP_FACTOR_ENABLED',
    GOOGLE_OTP: 'GOOGLE_OTP_FACTOR_ENABLED',
    OKTA_EMAIL: 'OKTA_EMAIL_FACTOR_ENABLED',
};
export const providerIdToSortOrder = {
    OKTA_PUSH: 0,
    OKTA_OTP: 1,
    GOOGLE_OTP: 2,
    OKTA_EMAIL: 3,
};
export const getGroupName = () => {
    return `${getClientId()}${DEFULT_GROUP_SUFFIX}`;
};
export const providerConfig = [
    {
        id: OKTA_PROVIDER_PUSH,
        sortOrder: providerIdToSortOrder[OKTA_PROVIDER_PUSH],
        name: 'mfa.auth.label.oktaVerify',
        enabled: false,
        description: 'mfa.auth.description.oktaVerifyPUSH',
        icon: IconID.OKTA_PROVIDER,
    },
    {
        id: OKTA_PROVIDER_OTP,
        sortOrder: providerIdToSortOrder[OKTA_PROVIDER_OTP],
        enabled: false,
        name: 'mfa.auth.label.oktaVerify',
        description: 'mfa.auth.description.oktaVerifyOTP',
        icon: IconID.OKTA_PROVIDER,
    },
    {
        id: GOOGLE_PROVIDER,
        sortOrder: providerIdToSortOrder[GOOGLE_PROVIDER],
        enabled: false,
        name: 'mfa.auth.label.googleAuthenticator',
        description: 'mfa.auth.description.googleAuthenticator',
        icon: IconID.GOOGLE_AUTH_PROVIDER,
    },
    {
        id: OKTA_PROVIDER_EMAIL,
        sortOrder: providerIdToSortOrder[OKTA_PROVIDER_EMAIL],
        enabled: false,
        name: 'mfa.auth.label.emailAuthenticator',
        description: 'mfa.auth.description.emailAuthenticator',
        icon: IconID.EMAIL_PROVIDER,
    },
];
export const getProviderConfigFromResponse = (mfaConfigInfo) => {
    const { providerConfig: providerStatus } = mfaConfigInfo;
    const newProviderConfig = [...providerConfig];
    Object.keys(providerStatus).forEach(function (provider) {
        if (Object.prototype.hasOwnProperty.call(providerIdToSortOrder, provider)) {
            newProviderConfig[providerIdToSortOrder[provider]].enabled =
                providerStatus[provider] === PROVIDER_ENABLED_STATUS;
        }
    });
    return newProviderConfig;
};
export const getConfigRequestFromProviderConfig = (providerConfig) => {
    const requestPayload = {
        groupName: getGroupName(),
    };
    const udpatedProviderConfig = {};
    for (let i = 0; i < providerConfig.length; i++) {
        udpatedProviderConfig[providerConfig[i].id] = providerConfig[i].enabled
            ? PROVIDER_ENABLED_STATUS
            : PROVIDER_DISABLED_STATUS;
    }
    return {
        ...requestPayload,
        providerConfig: udpatedProviderConfig,
        clientId: getClientId(),
        defaultHeaders: getDefaultSamlHeaders(),
    };
};
export const getMixPanelMetric = (status, providerUnderAciton) => {
    const mixpanelMetricActionType = status
        ? MFA_ENABLED_ACTION_TYPES[providerUnderAciton]
        : MFA_DISABLED_ACTION_TYPES[providerUnderAciton];
    return userActionTypeEnum[mixpanelMetricActionType];
};
//# sourceMappingURL=constants.js.map